import type { LandingHomeSectionKey } from '../../shared/editor/landingEditorTypes.js';

export const landingEditorSectionLabels: Record<LandingHomeSectionKey, string> = {
  hero: 'Hero',
  heroApplicant: 'Hero Bewerber',
  heroCompany: 'Hero Unternehmen',
  heroFanApplicant: 'Hero Fan Bewerber',
  heroFanCompany: 'Hero Fan Unternehmen',
  globusCampaignApplicant: 'GLOBUS Kampagne Bewerber',
  companyPlatformHero: 'Hero Unternehmen – Handschlag (Archiv)',
  companyPeopleHero: 'Hero Unternehmen – Menschen',
  globusCampaignCompany: 'GLOBUS Kampagne Unternehmen',
  companyObjections: 'Unternehmen – Fragen & Antworten',
  companyMatching: 'Unternehmen – Matching erleben',
  intro: 'Willkommen',
  industryOverview: 'Branchen',
  laborShortage: 'Fachkräftemangel',
  reasons: 'Warum Viva Porta',
  benefits: 'Vorteile',
  costs: 'Kosten',
  recognition: 'Anerkennung',
  requirements: 'Voraussetzungen',
  faqApplicant: 'FAQ Pflegekräfte',
  faqCompany: 'FAQ Arbeitgeber',
  quality: 'Qualität & Integration',
  knowledge: 'Wissen & Ratgeber',
  values: 'Werte',
  consultationApplicant: 'Erstberatung',
  consultationCompany: 'Personalbedarf',
  process: 'Ablauf',
  team: 'Team',
  story: 'Story',
  partners: 'Partner',
  globusPartner: 'Globus Partner',
  info: 'Informationen',
  contact: 'Kontakt',
};
